import { aosRefresh } from '../../../../../global/js/core/core';

function StepsB1() {
    /**
     * Steps B 1 custom container.
     * @param {HTMLElement} block
     */
    function init(block) {
        const cards = Array.from(block.querySelectorAll('.js-card'));
        if (!cards.length) {
            return;
        }

        cards.forEach((card) => {
            changeCardState(card);
        });
        aosRefresh();
    }

    /**
     * Fires on cards clicks. Note: this function was initially used for implementing "accordion" effect, but then it was decided to show cards always opened.
     * @param {Event} event
     */
    function cardClickHandler(event) {
        // Check if the clicks was on the card header.
        const header = event.target.closest('.js-card-header');
        if (!header) {
            return;
        }

        changeCardState(event.target);
    }

    /**
     * Shows hidden cards and hide the showed ones.
     * @param {HTMLElement} card
     */
    function changeCardState(card) {
        // Do nothing if no valid card is provided.
        if (!card) {
            return;
        }
        card = card.closest('.js-card-container');
        if (!card) {
            return;
        }
        // Check if the clicks was on the card header.
        const header = card.querySelector('.js-card-header');
        if (!header) {
            return;
        }

        // Check if content part exists.
        const body = card.querySelector('.js-card-body');
        if (!body) {
            return;
        }

        // Cards wrapper.
        const cardsWrapper = card.closest('.js-cards-wrapper');
        // Content width at the end of animation.
        const activeWidth = cardsWrapper
            ? `calc(${cardsWrapper.offsetWidth}px - 2 * 2rem)`
            : 'auto';
        // Card content wrapper element.
        const contentWrapper = card.querySelector('.js-card-content');
        // True if the card is "open".
        const isOpen = card.classList.contains('active');
        // Content element itself.
        const contentInner = contentWrapper.querySelector(
            '.js-card-content-inner',
        );
        // Title arrow.
        const titleArrow = card.querySelector('.js-title-arrow');

        if (isOpen) {
            contentWrapper.style.opacity = 0;
            if (titleArrow) {
                titleArrow.style.opacity = 0;
            }
            setTimeout(() => {
                jQuery(body).slideUp(300);
                card.classList.remove('active');
                if (contentInner) {
                    contentInner.style.width = 'auto';
                }
            }, 300);
        } else {
            card.classList.add('active');
            if (contentInner) {
                contentInner.style.width = activeWidth;
            }
            jQuery(body).slideDown(300, () => {
                contentWrapper.style.opacity = 1;
                if (titleArrow) {
                    titleArrow.style.opacity = 1;
                }
                contentInner.style.width = 'auto';
            });
        }
    }

    // Apply for all the Steps B 1 blocks on a page
    [...document.querySelectorAll(`[data-module='stepsB1']`)].forEach((block) =>
        init(block),
    );
}

export default StepsB1;
